import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"display":"flex","justify-content":"center"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxSelection = _resolveComponent("DxSelection")!
  const _component_DxFilterRow = _resolveComponent("DxFilterRow")!
  const _component_DxPaging = _resolveComponent("DxPaging")!
  const _component_DxLoadPanel = _resolveComponent("DxLoadPanel")!
  const _component_DxSorting = _resolveComponent("DxSorting")!
  const _component_DxSearchPanel = _resolveComponent("DxSearchPanel")!
  const _component_DxToolbarItem = _resolveComponent("DxToolbarItem")!
  const _component_DxPopup = _resolveComponent("DxPopup")!
  const _component_DxItem = _resolveComponent("DxItem")!
  const _component_DxFormGrid = _resolveComponent("DxFormGrid")!
  const _component_DxEditing = _resolveComponent("DxEditing")!
  const _component_DxColumn = _resolveComponent("DxColumn")!
  const _component_DxButton = _resolveComponent("DxButton")!
  const _component_DxToolbar = _resolveComponent("DxToolbar")!
  const _component_DxDataGrid = _resolveComponent("DxDataGrid")!
  const _component_DxTextArea = _resolveComponent("DxTextArea")!
  const _component_DxSimpleItem = _resolveComponent("DxSimpleItem")!
  const _component_DxDateBox = _resolveComponent("DxDateBox")!
  const _component_DxCheckBox = _resolveComponent("DxCheckBox")!
  const _component_DxForm = _resolveComponent("DxForm")!
  const _component_DxPopupAdd = _resolveComponent("DxPopupAdd")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_DxDataGrid, {
      "data-source": _ctx.dsSarbatoriLegale,
      ref: "dataGridRef",
      "allow-column-reordering": false,
      "allow-column-resizing": true,
      "column-auto-width": false,
      "show-borders": true,
      "key-expr": "Id"
    }, {
      editTitle: _withCtx(() => [...(_cache[1] || (_cache[1] = [
        _createElementVNode("div", { style: {"background-color":"#ff2c21","font-size":"15px","color":"white","font-weight":"bold","padding":"10px 0 10px 20px","width":"100%"} }, " Editare Sărbătoare Legală ", -1)
      ]))]),
      default: _withCtx(() => [
        _createVNode(_component_DxSelection, { mode: "single" }),
        _createVNode(_component_DxFilterRow, { visible: false }),
        _createVNode(_component_DxPaging, {
          "page-size": 10,
          "page-index": 0
        }),
        _createVNode(_component_DxLoadPanel, {
          enabled: true,
          "indicator-src": 'reload6.gif'
        }),
        _createVNode(_component_DxSorting, { mode: "multiple" }),
        _createVNode(_component_DxSearchPanel, {
          visible: true,
          width: 240,
          placeholder: "Cauta ..."
        }),
        _createVNode(_component_DxEditing, {
          "allow-updating": true,
          "allow-deleting": true,
          mode: "popup"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_DxPopup, {
              closeOnOutsideClick: false,
              showCloseButton: false,
              width: 500,
              height: 350,
              "show-title": true,
              "title-template": "editTitle"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_DxToolbarItem, {
                  toolbar: "bottom",
                  widget: "dxButton",
                  location: "center",
                  options: _ctx.saveButtonOptions
                }, null, 8, ["options"]),
                _createVNode(_component_DxToolbarItem, {
                  toolbar: "bottom",
                  widget: "dxButton",
                  location: "center",
                  options: _ctx.dangerButtonOptions
                }, null, 8, ["options"])
              ]),
              _: 1
            }),
            _createVNode(_component_DxFormGrid, null, {
              default: _withCtx(() => [
                _createVNode(_component_DxItem, { "data-field": "Nume" }),
                _createVNode(_component_DxItem, { "data-field": "Data" }),
                _createVNode(_component_DxItem, { "data-field": "InceputIntervalValabilitate" }),
                _createVNode(_component_DxItem, { "data-field": "SfarsitIntervalValabilitate" }),
                _createVNode(_component_DxItem, {
                  "data-field": "Anuala",
                  "editor-type": "dxCheckBox",
                  "css-class": 'checkbox-center',
                  "editor-options": { elementAttr: { style: 'display:flex; justify-content:center; margin-left:120px' } }
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Nume",
          caption: "Nume"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Data",
          caption: "Data"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Anuala",
          caption: "Anuala?"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "InceputIntervalValabilitate",
          caption: "Inceput Interval Valabilitate"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "SfarsitIntervalValabilitate",
          caption: "Sfarsit Interval valabilitate"
        }),
        _createVNode(_component_DxToolbar, null, {
          default: _withCtx(() => [
            _createVNode(_component_DxItem, {
              location: "after",
              name: "searchPanel"
            }),
            _createVNode(_component_DxItem, null, {
              default: _withCtx(() => [
                _createVNode(_component_DxButton, {
                  icon: "add",
                  type: "success",
                  onClick: _ctx.onAddClick
                }, null, 8, ["onClick"])
              ]),
              _: 1
            }),
            _createVNode(_component_DxItem, null, {
              default: _withCtx(() => [
                _createVNode(_component_DxButton, {
                  icon: "refresh",
                  onClick: _ctx.onRefreshClick
                }, null, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data-source"]),
    _createVNode(_component_DxPopupAdd, {
      visible: _ctx.addPopupVisible,
      "show-title": true,
      width: "500",
      height: "350"
    }, {
      title: _withCtx(() => [...(_cache[2] || (_cache[2] = [
        _createElementVNode("div", { style: {"background-color":"#ff2c21","font-size":"15px","color":"white","font-weight":"bold","padding":"10px","padding-left":"20px"} }, " Adăugare Sărbătoare Legală ", -1)
      ]))]),
      default: _withCtx(() => [
        _createVNode(_component_DxForm, {
          "col-count": 2,
          "data-source": _ctx.newSarbatoareLegala
        }, {
          default: _withCtx(() => [
            _createVNode(_component_DxSimpleItem, {
              "data-field": "Nume",
              "is-required": true
            }, {
              default: _withCtx(() => [
                _createVNode(_component_DxTextArea, {
                  value: _ctx.newSarbatoareLegala.Nume,
                  onValueChanged: _ctx.onNumeValueChanged,
                  height: "50px"
                }, null, 8, ["value", "onValueChanged"])
              ]),
              _: 1
            }),
            _createVNode(_component_DxSimpleItem, {
              "data-field": "Data",
              "is-required": true
            }, {
              default: _withCtx(() => [
                _createVNode(_component_DxDateBox, {
                  value: _ctx.newSarbatoareLegala.Data,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.newSarbatoareLegala.Data) = $event)),
                  type: "date",
                  "display-format": "dd-MM-yyyy",
                  "show-clear-button": true,
                  "label-mode": "floating",
                  height: "50px"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_DxSimpleItem, { "data-field": "Inceput Interval Valabilitate" }, {
              default: _withCtx(() => [
                _createVNode(_component_DxDateBox, {
                  value: _ctx.newSarbatoareLegala.InceputIntervalValabilitate,
                  type: "date",
                  "display-format": "dd-MM-yyyy",
                  "show-clear-button": true,
                  "label-mode": "floating",
                  height: "50px",
                  max: _ctx.newSarbatoareLegala.SfarsitIntervalValabilitate,
                  onValueChanged: _ctx.onInceputValabilitateChanged
                }, null, 8, ["value", "max", "onValueChanged"])
              ]),
              _: 1
            }),
            _createVNode(_component_DxSimpleItem, { "data-field": "Sfarsit Interval Valabilitate" }, {
              default: _withCtx(() => [
                _createVNode(_component_DxDateBox, {
                  value: _ctx.newSarbatoareLegala.SfarsitIntervalValabilitate,
                  type: "date",
                  "display-format": "dd-MM-yyyy",
                  "show-clear-button": true,
                  "label-mode": "floating",
                  height: "50px",
                  min: _ctx.newSarbatoareLegala.InceputIntervalValabilitate,
                  onValueChanged: _ctx.onSfarsitValabilitateChanged
                }, null, 8, ["value", "min", "onValueChanged"])
              ]),
              _: 1
            }),
            _createVNode(_component_DxSimpleItem, {
              "data-field": "Anuala?",
              "is-required": true,
              "col-span": 2
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  _createVNode(_component_DxCheckBox, {
                    value: _ctx.newSarbatoareLegala.Anuala,
                    onValueChanged: _ctx.onAnualaValueChanged
                  }, null, 8, ["value", "onValueChanged"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data-source"]),
        _createVNode(_component_DxToolbarItem, {
          widget: "dxButton",
          toolbar: "bottom",
          location: "center",
          options: _ctx.addButtonOptions
        }, null, 8, ["options"]),
        _createVNode(_component_DxToolbarItem, {
          widget: "dxButton",
          toolbar: "bottom",
          location: "center",
          options: _ctx.closeButtonOptions
        }, null, 8, ["options"])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}